module.exports = __webpack_public_path__ + "img/driver-success-back.97d5fdea.png";